// ============================================================================
// CabinetTasksTab.tsx — вкладка «Задачи» кабинета.
//
// Реальный список задач на существующих RPC (TaskService.ListTasks): тот же
// AutoListForm, что в «Предприятии» (вид/колонки/поиск/отборы/группировки),
// открытие записи — существующей AutoObjectForm. Сервер сам ограничивает
// выборку своими задачами и правами — клиент ничего не подменяет.
// ============================================================================

import { CabinetTypeListTab } from './CabinetTypeListTab';

export function CabinetTasksTab() {
  return (
    <CabinetTypeListTab
      kind="task"
      emptyText="Типы задач не настроены. Создайте тип задачи в конфигураторе — задачи появятся здесь."
    />
  );
}
